import axios from 'axios';
import appInfo from "../app-info";
import { apiHelper } from "./api_helper";

export const authApi = {
  signInSSO: async ({ access_token, id_token }) => {
    try {
      const res = await axios.post(
        appInfo.api_url + '/login',
        { access_token, id_token }
      );
      return res.data;
    } catch (error) {
      return {
        is_success: false
      }
    }
  },
  getUser: () => apiHelper.post('login/detail'),
  signOut: () => apiHelper.post('logout')
  

}